












import { Component, Mixins, Prop } from 'vue-property-decorator'
import BarraDePercentual from './BarraDePercentual.vue'
import CoresDoPainel from './CoresDoPainel'
import type { CategoriaDoMixDoCliente } from '@/models'
import { nomeDaCategoriaDoMix, textoDaParticipacaoNoMix } from '@/shareds/painel-do-cliente-mix-shareds'

@Component({
	components: {
		BarraDePercentual,
	},
})
export default class LinhaDeCategoriaDoMix extends Mixins(CoresDoPainel) {
	@Prop({ type: Object, required: true }) categoria!: CategoriaDoMixDoCliente

	get nome() {
		return nomeDaCategoriaDoMix(this.categoria)
	}

	get percentualDaBarra() {
		return this.categoria.pecas > 0 ? Math.max(1, this.categoria.pct) : this.categoria.pct
	}

	get participacao() {
		return textoDaParticipacaoNoMix(this.categoria)
	}
}
